import React from "react";

// Clean monogram for AI-ECO Suite — concentric "control plane" mark.
export default function Logo({ size = 28, withWordmark = true }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="logoGrad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#5B8DEF" />
            <stop offset="1" stopColor="#22C55E" />
          </linearGradient>
        </defs>
        <rect x="0.5" y="0.5" width="39" height="39" rx="10" stroke="rgba(255,255,255,0.10)" />
        <circle cx="20" cy="20" r="11" stroke="url(#logoGrad)" strokeWidth="1.6" />
        <circle cx="20" cy="20" r="5.5" fill="url(#logoGrad)" opacity="0.95" />
        <path d="M20 4.5 V 9" stroke="#5B8DEF" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M20 31 V 35.5" stroke="#22C55E" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
      {withWordmark && (
        <div className="leading-tight">
          <div className="font-display text-[15px] font-medium tracking-tight text-white">
            AI-ECO <span className="text-slate-400">Suite</span>
          </div>
          <div className="text-[10px] font-medium uppercase tracking-[0.18em] text-slate-500">
            Control Plane
          </div>
        </div>
      )}
    </div>
  );
}
